<template>
  <transition mode="out-in">
    <div class="row pt-5 pt-md-0 pb-5" key="produto">
      <div
        class="col-md-3 pt-4"
        v-for="(produto, index) in produtosVisiveis"
        :key="index"
      >
        <router-link
          v-if="produtosAtivos[produto.id] == 1 || produto.active == 'true'"
          :to="{ name: produto.id }"
          :aria-label="`Acessar ${produto.name}`"
        >
          <div
            class="card product shadow text-center d-flex justify-content-center"
            :class="{
              'product-featured': produto.id === 'assistenciafuneral',
            }"
          >
            <span v-if="produto.badge" class="product-badge">
              {{ produto.badge }}
            </span>
            <div class="card-body">
              <span class="material-icons">{{ produto.material_icon }}</span>
              <p class="card-title">{{ produto.name }}</p>
              <p class="card-text">{{ produto.desc }}</p>
              <span
                v-if="produto.id === 'assistenciafuneral'"
                class="product-call-to-action"
              >
                Conheça agora
                <span class="material-icons" aria-hidden="true">
                  arrow_forward
                </span>
              </span>
            </div>
          </div>
        </router-link>
      </div>

      <div class="col-md-3 pt-4" v-if="cardAdd">
        <div
          class="card add_produto"
          title="Adquirir mais produtos"
          data-toggle="modal"
          data-target="#adquirirNovoProduto"
        >
          <div class="card-body">
            <h1>+</h1>
          </div>
        </div>
      </div>

      <ModalNovoProduto />
    </div>
  </transition>
</template>

<script>
import { api } from "@/services.js";
import produtosList from "../produtos.json";
import produtosListConsultor from "../produtos_consultor.json";
import ModalNovoProduto from "@/components/NovoProdutoModal.vue";
export default {
  name: "ProdutosLista",
  components: {
    ModalNovoProduto,
  },
  props: ["urlParams"],
  data() {
    return {
      produtosLista: produtosList.produto,
      produtosPorPagina: 10,
      produtosAtivos: [],
      cardAdd: false,
    };
  },
  computed: {
    url() {
      const query = window.location.search;
      return `/produto${query}`;
    },
    produtosVisiveis() {
      return this.produtosLista.filter((p) => {
        const ativo =
          this.produtosAtivos[p.id] == 1 || p.active == "true" || p.active == 1; // em caso de número
        if (!ativo) return false;
        return true;
      });
    },
  },

  methods: {
    async getProdutos() {
      this.produtosLista = null;
      api.get(this.url).then((response) => {
        this.produtosLista = response.data;
      });
    },
    getProductsActive() {
      api.get("/api/CdlBh/ListaProdutosAtivos").then((response) => {
        this.produtosAtivos = response.data;
      });
    },
  },
  watch: {
    url() {},
  },
  created() {
    const dadosUsuario = this.$store.getters.getUsuario;
    if (dadosUsuario.carteira) {
      this.produtosLista = produtosListConsultor.produto;
    } else {
      this.produtosLista = produtosList.produto;
      this.cardAdd = true;
      this.getProductsActive();
    }
  },
};
</script>
<style lang="scss" scoped>
.product {
  position: relative;
}
.product-badge {
  background: #05428e;
  border: 3px solid white;
  border-radius: 20px;
  color: white;
  font-size: 0.62rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  padding: 0.3rem 0.6rem;
  position: absolute;
  right: -8px;
  top: -10px;
  z-index: 1;
}
.product-featured {
  background: linear-gradient(145deg, #ffffff 55%, #edf9f1 100%);
  border: 2px solid #00a04e;
  box-shadow: 0 8px 22px rgba(0, 90, 65, 0.2) !important;

  &::before {
    background: #00a04e;
    border-radius: 5px 5px 0 0;
    content: "";
    height: 6px;
    left: -2px;
    position: absolute;
    right: -2px;
    top: -2px;
  }

  .material-icons {
    color: #00a04e;
  }

  &:hover {
    box-shadow: 0 12px 26px rgba(0, 90, 65, 0.28) !important;
  }
}
.product-call-to-action {
  align-items: center;
  color: #05428e;
  display: inline-flex;
  font-size: 0.76rem;
  font-weight: 700;
  justify-content: center;
  margin-top: 0.55rem;
  text-transform: uppercase;

  .material-icons {
    font-size: 1rem;
    padding: 0 0 0 0.25rem;
  }
}
.add_produto {
  border: 2px dashed #00a04e;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 3rem;
  color: #00a04e;
  min-height: 200px;
  .card-body {
    display: flex;
    justify-content: center;
    align-items: center;
    transition: all 0.2s ease;
    cursor: pointer;
    &:hover {
    }
  }
}
</style>
